export default __webpack_public_path__ + "assets/images/2c2df632e79bbdbfe27d7fc9e05f1ec3.png";